import { useEffect, useState } from 'react';

const group = (int) => int.replace(/^0+(?=\d)/, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
const display = (v, decimals) => {
  if (v === '' || v == null || Number.isNaN(Number(v))) return '';
  const [int, dec] = String(Number(v)).split('.');
  const neg = int.startsWith('-');
  return (neg ? '-' : '') + group(int.replace('-', '')) + (dec && decimals ? ',' + dec.slice(0, decimals) : '');
};

export function MoneyInput({ value, onChange, name, decimals = 2, allowNegative = false, ...rest }) {
  const [text, setText] = useState(() => display(value, decimals));
  const [focus, setFocus] = useState(false);
  useEffect(() => { if (!focus) setText(display(value, decimals)); }, [value, focus, decimals]);
  const handle = (e) => {
    const raw = e.target.value;
    const neg = allowNegative && raw.trim().startsWith('-');
    const clean = raw.replace(/\./g, '').replace(/[^\d,]/g, '');
    const [int = '', ...rest] = clean.split(',');
    const dec = rest.length ? rest.join('').slice(0, decimals) : null;
    const shown = (neg ? '-' : '') + group(int) + (dec !== null && decimals ? ',' + dec : '');
    setText(shown);
    const num = int === '' && !dec ? '' : Number(`${neg ? '-' : ''}${int || 0}.${dec || 0}`);
    onChange({ target: { name, value: num, type: 'money' } });
  };
  return <input {...rest} name={name} type="text" inputMode="decimal" autoComplete="off" value={text} onChange={handle} onFocus={() => setFocus(true)} onBlur={() => setFocus(false)} />;
}
